import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { DocumentEditItemBase } from '../edit-item-base';

@Component({
    selector: 'fi-document-edit-item-sitemap',
    template: `
        <div class="document-edit-no-close text-left">
          @if (item && item.model && item.model.Contents) {
            <div class="document-image-options">
              @for (content of item.model.Contents; track content) {
                <div>
                  @if (IsLayoutLanguageSelected(content.ContentLanguageId) && selectedColumn === 1) {
                    <div
                      class="md-content md-padding edit-image-blocks"
                      >
                      <fi-widget-sitemap-edit
                        [(ngModel)]="content.Value.Col1"
                        (ngModelChange)="ngModelChange($event)"
                        />
                      </div>
                    }
                    @if (IsLayoutLanguageSelected(content.ContentLanguageId) && selectedColumn === 2) {
                      <div
                        class="md-content md-padding edit-image-blocks"
                        >
                        <fi-widget-sitemap-edit
                          [(ngModel)]="content.Value.Col2"
                          (ngModelChange)="ngModelChange($event)"
                          />
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
        `,
    encapsulation: ViewEncapsulation.None,
    styleUrl: './sitemap.component.scss',
    standalone: false,
})
export class DocumentEditItemSitemapComponent extends DocumentEditItemBase {
    constructor(injector: Injector) {
        super(injector);
    }

    ngModelChange($event) {
        this.contentChange.emit($event);
    }
}
